import React, { useState } from 'react';
import { DatePicker as MuiDatePicker } from '@mui/x-date-pickers';
import { IDateField } from './interfaces';
import { FormField } from '../FormField';
import { ClearFieldButton } from '../ClearFieldButton';

export const DateField: React.FC<IDateField> = ({
  label,
  helperText,
  required,
  error,
  value,
  disabled,
  disableFuture,
  disablePast,
  minDate,
  maxDate,
  onChange,
}): JSX.Element => {
  const [showDialog, setShowDialog] = useState<boolean>(false);

  return (
    <FormField
      label={label}
      helperText={helperText}
      required={required}
      error={error}
    >
      <ClearFieldButton onClear={() => onChange(null)} show={!!value}>
        <MuiDatePicker
          open={showDialog}
          onClose={() => setShowDialog(false)}
          value={value}
          onChange={(date) => onChange(date)}
          disabled={disabled}
          disableFuture={disableFuture}
          disablePast={disablePast}
          minDate={minDate}
          maxDate={maxDate}
          slotProps={{
            textField: {
              required: required,
              size: 'small',
              fullWidth: true,
              InputProps: {
                required: required,
                readOnly: true,
                onClick: () => setShowDialog(true),
              },
              error: !!error,
              sx: {
                fontSize: '0.9rem',
                input: {
                  fontSize: '0.9rem',
                },
                '& .MuiSvgIcon-root': {
                  fontSize: '16px',
                },
                '& .MuiPickersOutlinedInput-root': {
                  backgroundColor: '#fff',
                },
              },
            },
          }}
        />
      </ClearFieldButton>
    </FormField>
  );
};
